import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const RED = "#FF3008";
const GREEN = "#2E7D32";
const PAPER = "#FFF9F0"; // hero background — used for the dome stripe cutout

const useStyles = makeStyles(() => ({
  svg: {
    display: "block",
    width: "1.9em",
    height: "1.9em",
    overflow: "visible",
    animation: "$bob 0.6s ease-in-out infinite",
  },
  "@keyframes bob": {
    "0%, 100%": { transform: "translateY(0) rotate(-2deg)" },
    "50%": { transform: "translateY(-3px) rotate(-4deg)" },
  },
  legBack: {
    transformBox: "view-box",
    transformOrigin: "52px 74px",
    animation: "$swingBack 0.6s ease-in-out infinite",
  },
  "@keyframes swingBack": {
    "0%, 100%": { transform: "rotate(26deg)" },
    "50%": { transform: "rotate(-18deg)" },
  },
  legFront: {
    transformBox: "view-box",
    transformOrigin: "68px 74px",
    animation: "$swingFront 0.6s ease-in-out infinite",
  },
  "@keyframes swingFront": {
    "0%, 100%": { transform: "rotate(-22deg)" },
    "50%": { transform: "rotate(24deg)" },
  },
  line1: { animation: "$dash 0.6s linear infinite" },
  line2: { animation: "$dash 0.6s linear 0.2s infinite" },
  line3: { animation: "$dash 0.6s linear 0.4s infinite" },
  "@keyframes dash": {
    from: { opacity: 0.9, transform: "translateX(0)" },
    to: { opacity: 0.1, transform: "translateX(-9px)" },
  },
}));

/**
 * The RushMyFood cloche-on-the-run logo, rebuilt as SVG so the legs
 * actually swing in a little run cycle. Sized in `em` so it scales
 * with the surrounding text.
 */
function RunningLogo() {
  const classes = useStyles();
  return (
    <svg
      className={classes.svg}
      viewBox="0 0 120 120"
      aria-hidden="true"
      focusable="false"
    >
      {/* speed lines */}
      <g stroke={GREEN} strokeWidth="4.5" strokeLinecap="butt">
        <line className={classes.line1} x1="4" y1="82" x2="22" y2="82" />
        <line className={classes.line2} x1="0" y1="94" x2="15" y2="94" />
        <line className={classes.line3} x1="8" y1="106" x2="30" y2="106" />
      </g>
      {/* legs (each swings from its hip on the tray) */}
      <g className={classes.legBack}>
        <path
          d="M52 74 L38 92 L25 84"
          stroke={GREEN}
          strokeWidth="10"
          fill="none"
          strokeLinejoin="miter"
        />
      </g>
      <g className={classes.legFront}>
        <path
          d="M68 74 L82 100 L95 93"
          stroke={GREEN}
          strokeWidth="10"
          fill="none"
          strokeLinejoin="miter"
        />
      </g>
      {/* cloche dome + knob */}
      <circle cx="60" cy="22" r="7.5" fill={RED} />
      <path d="M24 65 A36 36 0 0 1 96 65 Z" fill={RED} />
      {/* stripe highlight on the dome */}
      <path
        d="M69 31 C78 39 84 51 85 64 L76 64 C75 52 70 41 62 33 Z"
        fill={PAPER}
      />
      {/* tray */}
      <rect x="12" y="65" width="96" height="10" rx="5" fill={GREEN} />
    </svg>
  );
}

export default RunningLogo;